<template>
  <v-row justify="center" class="my-n2">
    <v-col cols="12" :lg="type === 'three' ? 12 : 5">
      <v-row
        class="trafficlight mx-auto"
        :class="device.isDesktop ? '' : 'mt-auto ml-1'"
      >
        <template v-if="type === 'three'">
          <v-col
            cols="4"
            :class="!device.isDesktop && 'pa-0'"
            id="red"
            class="red fill-height white--text font-weight-bold text-h3 trafficlight-light"
          >
            <v-row
              no-gutters
              justify="center"
              align="center"
              class="fill-height"
              v-if="countdown"
            >
              <span :class="!device.isDesktop && 'text-caption'">
                {{ countdown }}
              </span>
            </v-row>
          </v-col>
          <v-col
            cols="4"
            id="yellow"
            :class="!device.isDesktop && 'pa-0'"
            class="yellow fill-height white--text font-weight-bold text-h4 trafficlight-light"
          >
            <v-row
              no-gutters
              justify="center"
              align="center"
              class="fill-height"
              v-if="countdown"
            >
              <span :class="!device.isDesktop && 'text-caption'">
                {{ countdown }}
              </span>
            </v-row>
          </v-col>
          <v-col
            cols="4"
            id="green"
            class="green fill-height white--text font-weight-bold trafficlight-light"
          ></v-col>
        </template>

        <v-col
          v-else-if="type === 'one'"
          cols="12"
          :class="currentLight"
          class="light fill-height white--text font-weight-bold text-h3 trafficlight-light pa-0"
        >
          <v-row
            v-if="currentLight !== 'green' && countdown"
            no-gutters
            justify="center"
            align="center"
            class="fill-height"
          >
            <span>
              {{ countdown }}
            </span>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    countdown: {
      type: Number,
    },
    type: {
      type: String,
      default: "three",
    },
    overlay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentLight: "green",
      interval: null,
    };
  },
  methods: {
    setLight(activeLight = "") {
      if (this.type !== "three") return;

      const lights = ["red", "yellow", "green"];
      lights.forEach((light) => {
        const el = document.getElementById(light);
        if (el) {
          el.style.opacity = light === activeLight ? "1" : "0.1";
        }
      });
    },
  },
  watch: {
    countdown() {
      if (this.countdown <= 3 && this.countdown > 0) {
        this.currentLight = "yellow";
        this.setLight("yellow");
      } else if (this.countdown === 0) {
        this.currentLight = "green";
        this.setLight("green");
      } else {
        this.currentLight = "red";
        this.setLight("red");
      }
    },
    overlay(newVal) {
      if (newVal) {
        this.currentLight = "red"; // Default to red when overlay is active
        this.setLight("red");
      } else {
        this.currentLight = "green"; // Default to green when overlay is inactive
        this.setLight("green");
      }
    },
  },
};
</script>
<style scoped>
.light {
  opacity: 1 !important;
}

.red,
.yellow {
  opacity: 0.1;
}

.trafficlight {
  background: #222;
  background-image: linear-gradient(
    transparent 2%,
    #111 2%,
    transparent 3%,
    #111 30%
  );
  border-radius: 20px;
  border: solid 5px #333;
  /* width is now set inline */
  padding: 4px;
}

.trafficlight-light {
  border-radius: 50%;
  aspect-ratio: 1;
  background-size: 5px 5px !important;
}

.red {
  background: red;
  background-image: radial-gradient(brown, transparent);
  border: dotted 2px red;
  box-shadow: 0 0 20px #111 inset, 0 0 10px red;
}

.yellow {
  background: yellow;
  background-image: radial-gradient(orange, transparent);
  border: dotted 2px yellow;
  box-shadow: 0 0 20px #111 inset, 0 0 10px yellow;
}

.green {
  background: green;
  background-image: radial-gradient(lime, transparent);
  box-shadow: 0 0 20px #111 inset, 0 0 10px lime;
  border: dotted 2px lime;
}
</style>
